import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Licenses from './views/Licenses.vue';
import BulkAdjustment from './views/BulkAdjustment.vue';
import VersionGuard from './views/VersionGuard.vue';
import LicenseList from './views/LicenseList.vue';
import { trackPageView } from '@/util/telemetry';

const routes: RouteRecordRaw[] = [
          {
              path: '/',
              name: 'Licenses',
              component: Licenses,
          },
          {
              path: '/bulk_adjustment',
              name: 'BulkAdjustment',
              component: BulkAdjustment,
          },
          {
              path: '/version_guard',
              name: 'VersionGuard',
              component: VersionGuard,
          },
          {
              path: '/license_list',
              name: 'LicenseList',
              component: LicenseList,
          },
      ];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.afterEach((to) => {
    trackPageView((to.name as string) ?? 'Unknown');
});

export default router;
